import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {ProductsLabelsModelService} from '../../../Models/Purchases/Products/products-labels-model.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsLabelsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ProductsLabelsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener las etiquetas de los productos
   *
   */
  public getProductsLabels(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getEtiquetas', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }
}
